<template>
  <div id="app" class="app-box">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang="scss">
  .app-box {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue